// Builds the whole printable page (every label, the grid and the cut lines) as HTML, exactly as the original doUpdate() did.
import { makeGutterLines } from './common';
import { generateQR, qrSize } from './qr';
import type { PageSpec } from '../model/pages';
import type { DrawOptions, Product } from '../model/types';

const trimmed = (p: Product): Product => ({
  ...p, name: p.name.trim(), desc: p.desc.trim(), price: p.price.trim(), compare: p.compare.trim(), sku: p.sku.trim(),
  ex1k: p.ex1k.trim(), ex1v: p.ex1v.trim(), ex2k: p.ex2k.trim(), ex2v: p.ex2v.trim(), qrText: p.qrText.trim(),
});

export async function renderPage(spec: PageSpec, o: DrawOptions, products: Product[], storeName: string, qrScratch: HTMLElement) {
  const store = storeName.trim();
  const n = spec.count(o.layout);
  const dims = spec.dims(o);
  const { labelW, labelH, cols, rows, pageW, pageH } = dims;
  const MARGIN = spec.margin, GAP = spec.gap;

  // Generate QR codes one at a time (one scratch box; already-made ones come from the cache)
  const qrSrcs: (string | null)[] = [];
  for(let i = 0; i < n; i++){
    const p = trimmed(products[i]!);
    qrSrcs.push(p.showQR && p.qrText ? await generateQR(qrScratch, p.qrText, qrSize(labelW, labelH)) : null);
  }

  // Build all label cells
  let cells = '';
  for(let i = 0; i < n; i++){
    const v = { ...trimmed(products[i]!), store };
    if(!v.name) v.name = n > 1 ? `Product ${i+1}` : 'Product Name';
    cells += `<div style="width:${labelW}px;height:${labelH}px;overflow:hidden;flex-shrink:0;">${spec.build(v,labelW,labelH,qrSrcs[i]!,n,o)}</div>`;
  }

  // Cut guide lines between labels (dashed hairlines)
  const gutterLines = makeGutterLines(cols, rows, labelW, labelH, pageW, pageH, MARGIN, GAP);

  const html = `
    <div style="
      position:relative;
      width:${pageW}px;height:${pageH}px;
      background:#fff;box-sizing:border-box;
      padding:${MARGIN}px;
    ">
      <div style="
        display:grid;
        grid-template-columns:repeat(${cols},${labelW}px);
        grid-template-rows:repeat(${rows},${labelH}px);
        gap:${GAP}px;
      ">${cells}</div>
      ${gutterLines}
    </div>`;
  return { html, n, dims };
}
